import React from 'react'
import { useEffect, useRef, useState } from 'react'
import '../Styles/AdministrationPortal.scss';
import AdminPortalSidebar from '../Components/AdminPortalSidebar';
import AdminPortalGuestTable from '../Components/AdminPortalGuestTable';
import AdminPortalGroupTable from '../Components/AdminPortalGroupTable';
import DateHelpers from '../Helper/DateHelpers.js';
import ResetPassword from '../Components/ResetPassword.js';
import { Link } from 'react-router-dom';
import { DateRangePicker } from 'react-date-range'
import Footer from "../Components/Footer.js";
import format from 'date-fns/format'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { Helmet } from "react-helmet";
import Navbar from '../Components/Navbar';
import { useNavigate } from 'react-router-dom';
function AdministrationPortal() {

   const [dashCampEvent, setDashCampEvent] = useState('All Camps');
   const [individualRegistrationData, setIndividualRegistrationData] = useState([]);
   const [groupRegistrationData, setGroupRegistrationData] = useState([])
   const [groupData, getGroupData] = useState([]);
   const [maleCounts, setMaleCounts] = useState([]);
   const [femaleCounts, setFemaleCounts] = useState([]);
   const [allCounts, setAllCounts] = useState([]);
   const [camper, setCamper] = useState([]);
   const [churchCounselor, setChurchCounselor] = useState([]);
   const [groupLeader, setGroupLeader] = useState([]);
   const [events, setEvents] = useState()
   const [eventStatus, setEventStatus] = useState(true)
   const [resetPasswordVisibility, setResetPasswordVisibility] = useState(false)
   const navigate = useNavigate()

   // Get Events
   const getEventsOnPageLoad = async () => {
      try {
         const eventResponse = await fetch('/getallevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventStatus })
         })

         const events = await eventResponse.json();
         var selectedEvents = events.data;
         console.log("Here's events", selectedEvents.eventInfo)
         setEvents(selectedEvents.eventInfo)

      } catch (error) {
         console.log(error)
      }
   }

   // Get Admin Data
   const getSelectedRegistrations = async (event) => {
      try {
         let eventId = event.target.value
         console.log("selected event id: ", eventId)
         const registrationResponse = await fetch('/individualadministration', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventId })
         })
         const registrationsForSelectedEvent = await registrationResponse.json();
         console.log("Here's Registrations", registrationsForSelectedEvent.data.selectedRegistrations)
         var weekRegistrations = registrationsForSelectedEvent.data.selectedRegistrations
         var femaleCounts = 0;
         var maleCounts = 0;
         var allCounts = 0;
         var groupLeaderCounts = 0;
         var churchCounselorCounts = 0;
         var camperCounts = 0;
         console.log("registration data", weekRegistrations)
         weekRegistrations.forEach(getCounts)
         console.log("female", femaleCounts)
         console.log("male", maleCounts)
         console.log("all", allCounts)
         console.log("camper", camperCounts)
         console.log("churchCounselor", churchCounselorCounts)
         console.log("groupLeader", groupLeaderCounts)
         function getCounts(item) {
            console.log("item", item)
            if (item.gender == "F") {
               femaleCounts += 1;
            }
            else if (item.gender == "M") {
               maleCounts += 1;
            }
            if (item.role == 'Church Counselor') {
               churchCounselorCounts += 1;
            }
            else if (item.role == 'Group Leader') {
               groupLeaderCounts += 1;
            }
            else if (item.role == 'Camper') {
               camperCounts += 1;
            }
            allCounts += 1
         }
         setChurchCounselor(churchCounselorCounts)
         setGroupLeader(groupLeaderCounts)
         setCamper(camperCounts)
         setMaleCounts(maleCounts)
         setFemaleCounts(femaleCounts)
         setAllCounts(allCounts)
         setIndividualRegistrationData(registrationsForSelectedEvent.data.selectedRegistrations)
      }
      catch (error) {
         console.log(error)
      }
   }

   async function getSelectedGroupRegistrations(event) {
      try {
         let eventId = event.target.value
         console.log("selected event id: ", eventId)
         const groupRegistrationRequest = await fetch('/groupadministration', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventId })
         })
         const groupRegistrationResponse = await groupRegistrationRequest.json()
         console.log("Group Registrations", groupRegistrationResponse)
         setGroupRegistrationData(groupRegistrationResponse.data.selectedRegistrations)
      } catch (error) {
         console.log(error)
      }
   }

   useEffect(() => {
      getEventsOnPageLoad()
   }, [eventStatus])

   let dropDownOptions = null;

   if (events) {
      console.log("Type", events)
      dropDownOptions = events.map((el) => <option key={el.camp_name} value={el.event_id}>{el.camp_name + ': ' + DateHelpers.getDisplayDate(el.begin_date) + '-' + DateHelpers.getDisplayDate(el.end_date)}</option>);
      console.log("options", dropDownOptions)
   }

   return (
      <div>
         <Navbar />
         <div className="adminPortalContent">
            <div className="AdminPortalForeground">
               <div className='adminHeading'>
                  <div className="adminHeadingText">
                     BRR Administration Tools
                  </div>
               </div>
               <div className="AdminFunctionButtonsContainer">
                  <div className="AdminFunctionButtonsItems">
                     <div className="transactionHelperButton">
                        <button onClick={() => navigate('/reservationsearch')}>
                           View Group Reservations
                        </button>
                     </div>
                     <div className="transactionHelperButton">
                        <button onClick={() => navigate('/registrationsearch')}>
                           View Camper Registrations
                        </button>
                     </div>
                     <div className="accountSearchButton">
                        <button onClick={() => navigate('/accountsearch')}>
                           View Accounts
                        </button>
                     </div>
                     <div className="accountSearchButton">
                        <button onClick={() => navigate('/groupaccountsearch')}>
                           View Group Accounts
                        </button>
                     </div>
                     <div className="resetPasswordButton">
                        <button onClick={() => setResetPasswordVisibility(!resetPasswordVisibility)}>
                           Reset Account Password
                        </button>
                     </div>
                  </div>
               </div>
               {/* <div className="selectDashEventForIndividualSelection">
                  <div className="selectDashEventDropdown">
                     <select
                        defaultValue={''}
                        onChange={(e) => getSelectedRegistrations(e)}>
                        <option value="Select Camp Type">Please Select Camp Week</option>
                        {
                           dropDownOptions
                        }
                     </select>
                  </div>
               </div> */}

               {/* <div className="adminPortalIndividualTableAndSideBar">
                     <div className="adminPortalSideBar">
                        <AdminPortalSidebar maleCounts={maleCounts} femaleCounts={femaleCounts} totalCounts={allCounts} groupLeader={groupLeader} churchCounselor={churchCounselor} camper={camper} />
                     </div>
                     <div className="adminPortalGuestTable">
                        <AdminPortalGuestTable registrationData={individualRegistrationData} />
                     </div>
               </div> */}


               {/* <div className="selectDashEventForGroupSelection">
                  <div className="selectEventGroupDropdown">
                     <select
                        defaultValue={''}
                        onChange={(e) => getSelectedGroupRegistrations(e)}>
                        <option value="Select Camp Type">Please Select Camp Week</option>
                        {
                           dropDownOptions
                        }
                     </select>
                  </div> */}
                  {/* <div className="selectEventStatusDropdown">
                     <select
                        defaultValue={''}
                        onChange={(e) => (setEventStatus(e.target.value))}>
                        <option value={true}>Upcoming Events</option>
                        <option value={false}>Archived Events</option>
                     </select>
                  </div> */}
               {/* </div> */}
               {/* <div className="adminPortalGroupTable">
                  <div className="adminPortalGroupTableContent">
                  <AdminPortalGroupTable registrationData={groupRegistrationData} />
                  </div>
               </div> */}
               {/* <div className="AdminFunctionButtonsContainer">
                  <div className="transactionHelperButton">
                     <button onClick={() => navigate('/registrationsearch')}>
                        Manage Camper Payments
                     </button>
                  </div>
                  <div className="resetPasswordButton">
                     <button onClick={() => setResetPasswordVisibility(!resetPasswordVisibility)}>
                        Reset Account Password
                     </button>
                  </div>
               </div> */}
               {/* { resetPasswordVisibility === true &&
                  <div>
                     <ResetPassword/>
                  </div>
               } */}
            </div>
         </div>
      </div>
   )
}
export default AdministrationPortal;

